/**
 * Set Leaflet's default marker icon so that any <Marker> without an explicit
 * icon has a valid icon. Prevents "Cannot read properties of undefined (reading 'createIcon')"
 * when markers are rendered before a map component sets the default, or when
 * icon is explicitly undefined.
 */
import L from 'leaflet';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const defaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
});

if (typeof L.Marker !== 'undefined') {
  L.Marker.prototype.options.icon = defaultIcon;
}
